import React, { useState } from 'react';

import { Action } from 'state';
import { NewTemplate } from 'types/Template';
import TemplateType from 'types/TemplateType';
import HcsPreviewer from './HcsPreviewer';
import JsonPreviewer from './JsonPreviewer';
import PreviewIconsBar, { ActiveIcon } from './PreviewIconsBar';

interface PreviewProps {
  template: NewTemplate;
  dispatch: (action: Action) => void;
}

const Preview: React.FC<PreviewProps> = ({ template, dispatch }) => {
  const [activeIcon, setActiveIcon] = useState<ActiveIcon>('hcs');
  const [jsonDisabled, setJsonDisabled] = useState(false);

  React.useEffect(() => {
    const disableJson =
      template.type === TemplateType.QA &&
      (template.exam_sections.some((section) => section.label === '' && !section.credits) ||
        !template.exam_sections.some((section) => section.credits));

    if (!jsonDisabled) {
      if (disableJson) {
        setActiveIcon('hcs');
        setJsonDisabled(true);
      } else {
        setJsonDisabled(false);
      }
    } else if (!disableJson) {
      setJsonDisabled(false);
    }
  }, [template.exam_sections]);

  return (
    <>
      <PreviewIconsBar activeIcon={activeIcon} onChange={setActiveIcon} jsonDisabled={jsonDisabled} />
      {activeIcon === 'hcs' ? (
        <HcsPreviewer template={template} dispatch={dispatch} />
      ) : activeIcon === 'json' ? (
        <JsonPreviewer template={template} />
      ) : null}
    </>
  );
};

export default Preview;
